import { createSelector } from 'reselect'

import { CoreRootState } from '../coreRoot.reducer'

export const helpPostList = createSelector(
  (state: CoreRootState) => state.helpStore.helpPosts,
  (state) => state,
)

export const helpPost = createSelector(
  (state: CoreRootState) => state.helpStore.helpPost,
  (state) => state,
)
